import { Observable, Subject, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConsumerSignInComponent } from './../../pages/components/landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { CommanSubscribeService } from './../../core/services/comman-subscribe.service';
import { StorageService } from './storage.service';
import { OrganizationInfo } from 'src/app/pages/components/communities/communities.component';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  private getfilterCategoryForHeaderSubject = new Subject<any>();
  private getSearchDataSubject = new Subject<any>();
  settingsData:any={}
  channelUrl: any;

  constructor(private router:Router,private _matDialog: MatDialog, private commanSubscribeService: CommanSubscribeService, private storageService: StorageService) {
    this.commanSubscribeService.getICWebpageThemeSettings().subscribe(data => {
      this.settingsData = data;
    });
   }

  getReturnUrl(): string {
    // First try to get returnUrl from query parameters
    const originalReturnUrl = this.storageService.getItem('originalReturnUrl');
    console.log('LandingPageService - Original returnUrl from storage:', originalReturnUrl);
    if (originalReturnUrl) {
      // Clear it after retrieving so it doesn't persist
      this.storageService.deleteItem('originalReturnUrl');
      return originalReturnUrl;
    }
    
    // If no returnUrl in query params, use current URL
    return '';
  }

  openConsumerSignIn(communityItem?: any, from?: string) {
    const timeOut = from === 'community' ? 3000 : 0;
    setTimeout(() => {
    this.channelUrl = this.storageService.getItem('channelName')
    console.log("openConsumerSignIn - settings22",this.channelUrl,"this.router.url",this.router.url)
    if(!this.router.url.includes(this.channelUrl)){
      console.log("openConsumerSignIn - settings11",this.settingsData,Object.keys(this.settingsData).length)
      this.settingsData={}
    }
    console.log("openConsumerSignIn - settings",this.settingsData,Object.keys(this.settingsData).length)
    // Get the returnUrl from query params or current URL
    const returnUrl = this.getReturnUrl();
    // let device = this.commanSubscribeService.getMobileOperatingSystem();
    // if (device == 'web') {
      const dialogRef = this._matDialog.open(ConsumerSignInComponent, {
        maxWidth: "400px",
        panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ?"app-consumer-signin": "app-consumer-sign-in",
        disableClose: true,
        data: { 
          communityItem: communityItem, // Pass the community item data
          url: returnUrl // Pass the return URL
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == "yes") {
        }
      });
    // }else{
    //   this.commanSubscribeService.sendDeviceType(device);
    // }
    }, timeOut);
  }


  sendfilterCategory(data: any) {
    this.getfilterCategoryForHeaderSubject.next(data);
  }
  getfilterCategory(): Observable<any> {
    return this.getfilterCategoryForHeaderSubject.asObservable();
  }

  sendSearchData(data: any) {
    this.getSearchDataSubject.next(data);
  }
  getSearchData(): Observable<any> {
    return this.getSearchDataSubject.asObservable();
  }


}
